import { PROJECT_CODE_LENGTH } from '@/features/project/_utils/code-formatter';
import { getCodeMaxValue } from '../utils/get-code-max-value';

export const RESERVED_PROJECT_CODE_MAX_VALUE =
  getCodeMaxValue(PROJECT_CODE_LENGTH);
